'use client';

import type { ReactNode } from 'react';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { DimensionFragmentFragmentDoc } from '@packages/gql/generated/shopping/DimensionFragmentFragmentDoc';
import { ColorTilesDimension } from './ColorTilesDimension/ColorTilesDimension';
import { TilesDimension } from './TilesDimension/TilesDimension';
import { SelectDimension } from './SelectDimension/SelectDimension';
import type { SetSelectedVariation } from '../types/types';

/* GraphQL */ `
  fragment DimensionFragment on ProductDimension {
    axisType
    displayName
    type
    ...TilesValuesFragment
    ...ColorTilesValuesFragment
    ...SelectValuesFragment
  }
`;

export type VariationSelectProps = {
  /**
   * The GraphQL dimension data for the given product
   */
  dimensionData: FragmentType<typeof DimensionFragmentFragmentDoc>;
  onChange?: SetSelectedVariation;
  sampleOrderLink: ReactNode;
};

/**
 * VariationSelect component decides which component-type to be rendered:
 * There are multiple ways, a product and its variations can be selected (e.g. Select, Tiles, ...).
 * Depending on configuration and backend-data, this component chooses a suiting
 * display-type.
 * */
export const VariationSelect = ({
  dimensionData,
  onChange,
  sampleOrderLink,
}: VariationSelectProps) => {
  const dimension = getFragmentData(DimensionFragmentFragmentDoc, dimensionData);

  let content = <SelectDimension dimensionData={dimension} onChange={onChange} />;

  if (dimension.axisType === 'COLOR' && dimension.type === 'TILES') {
    content = <ColorTilesDimension dimensionData={dimension} onChange={onChange} />;
  }

  if (dimension.axisType !== 'COLOR' && dimension.type === 'TILES') {
    content = <TilesDimension dimensionData={dimension} onChange={onChange} />;
  }
  return (
    <div>
      <p>{dimension.displayName}</p>
      <div className="mt-1">{content}</div>
      {sampleOrderLink !== null && dimension.axisType === 'COLOR' && sampleOrderLink}
    </div>
  );
};
